module.exports = __webpack_public_path__ + "static/img/NP.26a276a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NP.png
// module id = Xpmi
// module chunks = 1